import { render, staticRenderFns } from "./ResumenSolicitud.vue?vue&type=template&id=573138fc&scoped=true"
import script from "./ResumenSolicitud.vue?vue&type=script&lang=js"
export * from "./ResumenSolicitud.vue?vue&type=script&lang=js"
import style0 from "./ResumenSolicitud.vue?vue&type=style&index=0&id=573138fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573138fc",
  null
  
)

export default component.exports